import type {TranslationKey} from '#build/i18n';

export function ctaTranslationKey(type: string): TranslationKey {
    switch (type) {
        case 'successStory':
            return 'resources.successStories.readLink';
        case 'collection':
            return 'resources.collection';
        case 'event':
            return 'resources.events.signup';
        case 'trends':
            return 'resources.trends.readLink';
        case 'pressRelease':
            return 'resources.pressReleases.read';
        default:
            return `resources.${type}s.readLink` as TranslationKey;
    }
}
